import rem from 'polished/lib/helpers/rem'
import * as React from 'react'
import styled from 'styled-components'

const Root = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  display: grid;
  margin: 0;
  gap: ${rem(20)};
  // Cards are inserted before the remaining skeletons as prices resolve. Do not
  // let the browser follow a moving skeleton and scroll past the loaded offers.
  overflow-anchor: none;

  @media (min-width: 576px) {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, ${rem(280)}), 1fr));

    &.item-count-1 {
      grid-template-columns: repeat(1, minmax(min(100%, ${rem(280)}), ${rem(348)}));
    }

    &.item-count-2 {
      grid-template-columns: repeat(2, minmax(min(100%, ${rem(280)}), ${rem(348)}));
    }

    > * {
      width: 100%;
      min-height: ${rem(416)};
    }
  }
`

interface Props {
  children: React.ReactNode
}

function CalendarPickerGridLayout(props: Props) {
  const tiles = React.Children.toArray(props.children).filter(Boolean)
  const itemCount = tiles.length
  const className = itemCount === 1 ? 'item-count-1' : itemCount === 2 ? 'item-count-2' : undefined

  return (
    <Root className={className} data-testid="flexwrap-recommendations">
      {tiles}
    </Root>
  )
}

export default CalendarPickerGridLayout
